<template>
    <div>
    </div>
</template>

<script>

export default {
    name: "recaptcha",
    props: {
        sitekey: String,
    },

    data () {
        return {
            widgetId: null,
        }
    },

    methods: {
        emitVerify (e) {
            this.$emit('verify', e)
        },

        reset() {
            if (!this.widgetId) 
                return

            grecaptcha.ready( function() {
                this.widgetId = grecaptcha.reset(this.widgetId)
            })
        },

        onload () {


            this.render();
        },
        render () {

            let params = {
                callback: this.emitVerify,
                sitekey: this.sitekey,
                size: this.compact ? 'compact' : 'normal'
            }

            let container = this.$slots.default ? this.$el.children[0] : this.$el

            grecaptcha.ready( function() {
                let id = grecaptcha.render( container, params )

            })


        }
    },



    mounted () {
        if (!window.grecaptcha) {
            let script = document.createElement('script')
            script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=explicit')
            script.async = true
            script.onload = (e) => {
                this.onload()
            }
            document.head.appendChild(script) 
        } else {
            this.render()
        }
    }
}

</script>